import './email.css';
const Email = () => {
    return (
        <p className='email text-center'>
            gabriela@dlugaro.com.pe
        </p>
    )
}

export default Email